import * as React from 'react';
import { useEffect, useState } from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2, VisuallyHidden } from '@coursera/cds-core';

import _t from 'i18n!nls/portfolio-projects';

type Props = {
  characterLimit: number;
  charactersLeft: number;
  id?: string;
  isLimitReached?: boolean;
  className?: string;
};

const CharacterLimit = (props: Props) => {
  const { className, charactersLeft, characterLimit, isLimitReached, id } = props;

  const [announcedCharactersLeft, setAnnouncedCharactersLeft] = useState(charactersLeft);

  useEffect(() => {
    const ratio = charactersLeft / characterLimit;

    // Announce when  100% || 50% || 10% || less than or equal 0% of the limit left
    if (ratio === 0.5 || ratio === 0.1 || ratio === 1 || ratio <= 0) {
      setAnnouncedCharactersLeft(charactersLeft);
    }
  }, [characterLimit, charactersLeft]);

  return (
    <>
      <VisuallyHidden id={id}>
        <FormattedMessage
          message={_t('You can enter up to {number, plural, one {# character} other {# characters} }')}
          number={characterLimit}
        />
      </VisuallyHidden>
      <Typography2
        component="p"
        aria-hidden
        className={className}
        color={isLimitReached ? 'error' : 'supportText'}
        variant="bodySecondary"
      >
        {isLimitReached ? (
          <FormattedMessage
            message={_t('{number, plural, =1 {# character} other {# characters} } too many')}
            number={Math.abs(charactersLeft)}
          />
        ) : (
          <FormattedMessage
            message={_t('{number, plural, one {# character} other {# characters} } remaining')}
            number={charactersLeft}
          />
        )}
      </Typography2>
      <VisuallyHidden aria-live="polite">
        {isLimitReached ? (
          <FormattedMessage
            message={_t('You have {number, plural, one {# character} other {# characters} } too many')}
            number={Math.abs(announcedCharactersLeft)}
          />
        ) : (
          <FormattedMessage
            message={_t('You have {number, plural, one {# character} other {# characters} } remaining')}
            number={announcedCharactersLeft}
          />
        )}
      </VisuallyHidden>
    </>
  );
};

export default CharacterLimit;
